import { useLocale } from "../i18n/LocaleContext";
import { Reveal, Eyebrow } from "../components/Reveal";

function Block({ title, children, testid }) {
  return (
    <Reveal>
      <div className="border-t border-imperium-champagne/50 py-10" data-testid={testid}>
        <h2 className="text-[11px] font-label uppercase tracking-[0.3em] text-imperium-bronze">{title}</h2>
        <div className="mt-5 max-w-2xl space-y-3 text-base font-light leading-relaxed text-imperium-black/75">{children}</div>
      </div>
    </Reveal>
  );
}

export default function Legal({ type }) {
  const { t } = useLocale();

  return (
    <div data-testid={`legal-${type}-page`}>
      <section className="mx-auto max-w-[1100px] px-6 pb-24 pt-40 sm:px-10 lg:pt-52">
        <Reveal>
          <Eyebrow>IMPERIUM Beauty &amp; Wellness</Eyebrow>
          <h1 className="mt-6 font-serif text-5xl font-light text-imperium-black sm:text-6xl">
            {type === "impressum" ? t("impressum.title") : t("privacyPage.title")}
          </h1>
        </Reveal>
        <div className="mt-16">
          {type === "impressum" ? (
            <>
              <Block title={t("impressum.operatorLabel")} testid="impressum-operator">
                <p className="font-serif text-2xl font-light text-imperium-black">{t("impressum.operator")}</p>
                <p>Austrasse 31<br />4051 Basel<br />Switzerland</p>
              </Block>
              <Block title={t("impressum.contactLabel")} testid="impressum-contact">
                <p>
                  <a href="mailto:kontakt@imperium-wellness.ch" className="link-line">kontakt@imperium-wellness.ch</a>
                </p>
                <p><a href="tel:+41786136096" className="link-line">+41 78 613 60 96</a></p>
                <p><a href="https://www.imperium-wellness.ch" target="_blank" rel="noopener noreferrer" className="link-line">www.imperium-wellness.ch</a></p>
              </Block>
              <Block title={t("impressum.contentLabel")} testid="impressum-content">
                <p>Leidiane Alcântara</p>
              </Block>
              <Block title="Note" testid="impressum-note">
                <p className="text-sm italic text-imperium-black/55">{t("impressum.note")}</p>
              </Block>
            </>
          ) : (
            <>
              <Block title={t("privacyPage.responsibleTitle")} testid="privacy-responsible">
                <p>{t("privacyPage.responsibleText")}</p>
              </Block>
              <Block title={t("privacyPage.dataTitle")} testid="privacy-data">
                <p>{t("privacyPage.dataText")}</p>
              </Block>
              <Block title={t("privacyPage.storageTitle")} testid="privacy-storage">
                <p>{t("privacyPage.storageText")}</p>
              </Block>
              <Block title={t("privacyPage.rightsTitle")} testid="privacy-rights">
                <p>{t("privacyPage.rightsText")}</p>
              </Block>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
